import CreatorSponsorshipPage from "./CreatorSponsorshipPage";

export default CreatorSponsorshipPage;
